// ============================================================
// FILE: resources/js/components/countdown.js
// USPATIH GO — Alpine Component: Countdown Timer (Undangan)
// ============================================================

import Alpine from 'alpinejs';

Alpine.data('countdown', (targetDate) => ({
  days:     0,
  hours:    0,
  minutes:  0,
  seconds:  0,
  interval: null,

  init() {
    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  },

  /**
   * Hitung selisih waktu dari sekarang ke targetDate
   */
  update() {
    const diff = new Date(targetDate) - new Date();

    if (diff <= 0) {
      clearInterval(this.interval);
      this.days = this.hours = this.minutes = this.seconds = 0;
      return;
    }

    this.days    = Math.floor(diff / 86400000);
    this.hours   = Math.floor((diff % 86400000) / 3600000);
    this.minutes = Math.floor((diff % 3600000)  / 60000);
    this.seconds = Math.floor((diff % 60000)    / 1000);
  },

  destroy() {
    clearInterval(this.interval);
  },
}));
